/**
 * @Author: mojuejun
 * @Date: 2025-06-03
 * @Explain: WhatsApp 活动管理
 */
import type { TemplateItem } from '@/api/whatsAppTemplate/data';

export interface ActivityWhatsAppState {
  /** 是否显示创建 WhatsApp 活动弹窗 */
  createWhatsAppOptions: {
    isShow: boolean;
  };
  /** 是否内部跳转 */
  isInternalJump: boolean;
  /** 是否开启跳出拦截 */
  isLeaveFlag: boolean;
  /** 选择内容 - 语言tab选中项 */
  languageActive: string;
  /** 草稿缓存 */
  draftCache: {
    id: number;
    name: string;
    time: number;
    saveList: any[];
    expandedList: any[];
  };
  /** 模板缓存 */
  templateCache: {
    [key: string]: TemplateItem;
  };
}

export interface ActivityWhatsAppReducers {
  setCreateWhatsAppOptions: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
  setInterceptRouteStatus: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
  setTabsActive: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
  setDraftCache: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
  resetDraftCache: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
  setTemplateCache: (
    state: ActivityWhatsAppState,
    action: { payload: any },
  ) => any;
}

export type ModelType = {
  namespace: string;
  state: ActivityWhatsAppState;
  reducers: ActivityWhatsAppReducers;
};

const ActivityWhatsAppModel: ModelType = {
  namespace: 'ActivityWhatsAppModel',
  state: {
    // 是否显示创建 WhatsApp 活动弹窗
    createWhatsAppOptions: {
      isShow: false,
    },
    // 是否内部跳转
    isInternalJump: false,
    // 是否开启跳出拦截
    isLeaveFlag: false,
    // 选择内容 - 语言tab选中项
    languageActive: '',
    // 草稿缓存
    draftCache: {
      id: 0,
      name: '',
      time: 0,
      saveList: [],
      expandedList: [],
    },
    // 模板缓存
    templateCache: {},
  },
  reducers: {
    // 设置 WhatsApp 活动弹窗配置
    setCreateWhatsAppOptions(state, action) {
      return {
        ...state,
        createWhatsAppOptions: action.payload,
      };
    },
    // 设置拦截路由状态
    setInterceptRouteStatus(state, action) {
      const { isInternalJump, isLeaveFlag } = action.payload;
      return {
        ...state,
        isInternalJump,
        isLeaveFlag,
      };
    },
    // 设置选择内容 - 语言tab选中项
    setTabsActive(state, action) {
      return {
        ...state,
        languageActive: action.payload,
      };
    },
    // 设置草稿缓存
    setDraftCache(state, action) {
      return {
        ...state,
        draftCache: action.payload,
      };
    },
    // 重置草稿缓存
    resetDraftCache(state, action) {
      return {
        ...state,
        draftCache: {
          id: 0,
          time: 0,
          saveList: [],
          expandedList: [],
        },
        languageActive: '',
      };
    },
    // 设置模板缓存
    setTemplateCache(state, action) {
      return {
        ...state,
        templateCache: {
          ...state.templateCache,
          ...action.payload,
        },
      };
    },
  },
};

export default ActivityWhatsAppModel;
